import React from 'react';
import theme from 'shared/constants/theme.json';

export default () => {
  const textSecondary = theme['text-color-secondary'];
  const borderColor = theme['border-color-base'];
  const primaryColor = theme['primary-color'];

  return (
    <svg width="230" height="280" viewBox="0 0 230 280" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="229" height="279" fill="white" />
      <rect width="230" height="15" fill="#EEEEEE" />
      <path d="M0 7C0 5.89543 0.895431 5 2 5H43C44.1046 5 45 5.89543 45 7V15H0V7Z" fill="#C4C4C4" />
      <path d="M47 7C47 5.89543 47.8954 5 49 5H90C91.1046 5 92 5.89543 92 7V15H47V7Z" fill={primaryColor} />
      <path d="M46.9977 37H183.405M84.8332 53.5854H144.573" stroke={textSecondary} strokeWidth="3" />
      <path d="M12.6492 151.368V74.751L114.423 113.297L12.6492 151.368ZM13.5197 152.11L115.841 113.834L216.9 152.11H13.5197ZM217.753 151.364L117.262 113.303L217.753 75.7124V151.364ZM217.753 74.6447L115.843 112.766L13.7148 74.0853H217.753V74.6447Z" stroke={textSecondary} />
      <path d="M22.1059 176.024H56.9544V174.073H22.1059V176.024Z" fill={textSecondary} />
      <path d="M60.9371 183.829H16.1319V182.854H60.9371V183.829Z" fill={textSecondary} />
      <path d="M55.9587 195.537H16.1319V194.561H55.9587V195.537Z" fill={textSecondary} />
      <path d="M16.1319 207.244H60.9371V206.268H16.1319V207.244Z" fill={textSecondary} />
      <path d="M60.9371 218.951H16.1319V217.976H60.9371V218.951Z" fill={textSecondary} />
      <path d="M16.1319 187.732H50.9804V186.756H16.1319V187.732Z" fill={textSecondary} />
      <path d="M50.9804 199.439H16.1319V198.463H50.9804V199.439Z" fill={textSecondary} />
      <path d="M16.1319 211.146H50.9804V210.171H16.1319V211.146Z" fill={textSecondary} />
      <path d="M50.9804 222.854H16.1319V221.878H50.9804V222.854Z" fill={textSecondary} />
      <path d="M16.1319 191.634H60.9371V190.659H16.1319V191.634Z" fill={textSecondary} />
      <path d="M55.9587 203.341H16.1319V202.366H55.9587V203.341Z" fill={textSecondary} />
      <path d="M16.1319 215.049H55.9587V214.073H16.1319V215.049Z" fill={textSecondary} />
      <path d="M60.9371 226.756H16.1319V225.78H60.9371V226.756Z" fill={textSecondary} />
      <path d="M99.7683 176.024H134.617V174.073H99.7683V176.024Z" fill={textSecondary} />
      <path d="M138.599 183.829H93.7943V182.854H138.599V183.829Z" fill={textSecondary} />
      <path d="M133.621 195.537H93.7943V194.561H133.621V195.537Z" fill={textSecondary} />
      <path d="M93.7943 207.244H138.599V206.268H93.7943V207.244Z" fill={textSecondary} />
      <path d="M138.599 218.951H93.7943V217.976H138.599V218.951Z" fill={textSecondary} />
      <path d="M93.7943 187.732H128.643V186.756H93.7943V187.732Z" fill={textSecondary} />
      <path d="M128.643 199.439H93.7943V198.463H128.643V199.439Z" fill={textSecondary} />
      <path d="M93.7943 211.146H128.643V210.171H93.7943V211.146Z" fill={textSecondary} />
      <path d="M128.643 222.854H93.7943V221.878H128.643V222.854Z" fill={textSecondary} />
      <path d="M93.7943 191.634H138.599V190.659H93.7943V191.634Z" fill={textSecondary} />
      <path d="M133.621 203.341H93.7943V202.366H133.621V203.341Z" fill={textSecondary} />
      <path d="M93.7943 215.049H133.621V214.073H93.7943V215.049Z" fill={textSecondary} />
      <path d="M138.599 226.756H93.7943V225.78H138.599V226.756Z" fill={textSecondary} />
      <path d="M177.431 176.024H212.279V174.073H177.431V176.024Z" fill={textSecondary} />
      <path d="M216.262 183.829H171.457V182.854H216.262V183.829Z" fill={textSecondary} />
      <path d="M211.283 195.537H171.457V194.561H211.283V195.537Z" fill={textSecondary} />
      <path d="M171.457 207.244H216.262V206.268H171.457V207.244Z" fill={textSecondary} />
      <path d="M216.262 218.951H171.457V217.976H216.262V218.951Z" fill={textSecondary} />
      <path d="M171.457 187.732H206.305V186.756H171.457V187.732Z" fill={textSecondary} />
      <path d="M206.305 199.439H171.457V198.463H206.305V199.439Z" fill={textSecondary} />
      <path d="M171.457 211.146H206.305V210.171H171.457V211.146Z" fill={textSecondary} />
      <path d="M206.305 222.854H171.457V221.878H206.305V222.854Z" fill={textSecondary} />
      <path d="M171.457 191.634H216.262V190.659H171.457V191.634Z" fill={textSecondary} />
      <path d="M211.283 203.341H171.457V202.366H211.283V203.341Z" fill={textSecondary} />
      <path d="M171.457 215.049H211.283V214.073H171.457V215.049Z" fill={textSecondary} />
      <path d="M216.262 226.756H171.457V225.78H216.262V226.756Z" fill={textSecondary} />
      <rect x="0.5" y="0.5" width="229" height="279" stroke={borderColor} />
    </svg>
  );
};
